<template>
  <div class="batterySwapOrderMgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">分账关系管理</p>
      <p v-if="view=='add'||view=='edit'" @click="cancelHandle">分账关系管理</p>
      <p v-if="view=='add'">>新增</p>
      <p v-if="view=='edit'">>编辑</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <!--        <span>分账关系编号：</span>-->
        <!--        <el-input class="list-input" size="mini" v-model="number"></el-input>-->
        <span class="ml10">所属组织：</span>
        <el-cascader
          class="fixed-width-200"
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
          clearable></el-cascader>
        <span class="ml10">创建时间：</span>
        <div class="value-label">
          <el-date-picker
            v-model="beginTime"
            class="date-global"
            size="mini"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            placeholder="选择开始时间">
          </el-date-picker>
          <span>-</span>
          <el-date-picker
            v-model="endTime"
            size="mini"
            class="date-global"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            placeholder="选择结束时间">
          </el-date-picker>
        </div>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="onAddBtnClick">新增分账关系</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="170">分账关系编号</th>
          <th>创建时间</th>
          <th>关联商品名称</th>
          <th>关联商品类型</th>
          <th>关联商品规格</th>
          <th>关联商品单价</th>
          <th>所属组织</th>
          <th width="170">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.createTimeStr }}</td>
          <td>{{ item.title }}</td>
          <td>{{ typeMap[item.type] }}</td>
          <td>{{ item.standard }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.unitName }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onEditBtnClick(item)">编辑</div>
            <div class="text-btn fixed-width-75" @click="onDeleteBtnClick(item)">删除</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="8">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条</div>
        <!--          ，共{{total}}条-->
        <div class="page-count">跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'||view == 'edit'">
      <sub-account-detail-view :editData="editData" @cancel="cancelHandle"></sub-account-detail-view>
    </div>
  </div>
</template>

<script>
import Utils from '../../utils/utils.js'
import {parseTime} from "../../utils/index.js";
import subAccountDetailView from "./subAccountDetailView";

export default {
  name: 'returnOrderMgmt',
  components: {subAccountDetailView},
  data() {
    return {
      view: 'list',
      number: "",
      pageIndex: 1,
      page: 1,
      // total:'',
      // totalPage:0,
      unitNo: [],
      unitList: [],
      pageSize: 10,
      beginIndex: 0,
      beginTime: "",
      endTime: "",
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dataList: [],
      editData: {},
      typeMap: {
        '1': '直流充电服务',
        '2': '换电服务',
        '3': '交流充电服务',
        '4': '换电卡',
        '5': '充电卡',
        '6': '电池',
        '7': '电池适配器',
        '8': '充电柜充电服务',
        '9': '电动车',
        '10': '租车卡'
      },
    }
  },
  mounted() {
    this.beginTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    this.getUnitMember();
    this.getDataList();
  },
  methods: {
    getUnitMember() {
      let self = this;
      let params = {
        authorityType: 226
      }
      this.$http.post('/managementPlatform/unit/queryManagedUnit', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
    getDataList: function () {
      var self = this;
      var params = {
        commodityNo: this.number,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.beginTime,
        endTime: this.endTime,
        unitNo: this.unitNo[this.unitNo.length - 1],
      };
      this.$http.post("/managementPlatform/fund/listDistributeRelation", this.$qs.stringify(params)).then(function (response) {
        var res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          })
          return;
        }
        res.ldata.forEach(v => {
          v.createTimeStr = parseTime(v.createTime)
        })
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        // self.total = res.mdata.total;
        // self.totalPage = Math.floor((parseInt(res.mdata.total)-1)/self.pageSize)+1;
      }).catch(function (response) {

      });
    },
    onQueryBtnClick: function () {
      this.dataList = [];
      this.beginIndex = 0;
      this.getDataList();
    },
    onPageChooseBtnClick() {
      let index = 0;
      // if(this.page <= this.totalPage && this.page>0){
      index = this.page;
      // }else{
      //     index = 1;
      //     this.page = 1;
      // }
      this.beginIndex = (index - 1) * this.pageSize;
      this.getDataList();
    },
    onPreBtnClick: function () {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.getDataList();
    },
    onNextBtnClick: function () {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.getDataList();
    },
    resetPreAndNextBtn: function (length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onAddBtnClick() {
      this.view = 'add';
    },
    onEditBtnClick(data) {
      this.view = 'edit';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    onDeleteBtnClick(item) {
      var self = this;
      this.$confirm('是否确定删除?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.deleteItem(item);
      }).catch(action => {
      });
    },
    deleteItem(item) {
      let self = this;
      let params = {
        commodityNo: item.commodityNo,
      };
      this.$http.post('/managementPlatform/fund/deleteDistributeRelation', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        self.$message.success('删除成功！');
        self.getDataList();
      }).catch(function (response) {
        console.log(response);
      });
    },
    cancelHandle() {
      this.view = 'list';
      this.getDataList();
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
      display: inline-block;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/subAccountMgmt.vue